if ( typeof VideoComponent !== 'function' ) {

  class VideoComponent extends HTMLElement {

    constructor() {

      super();
    
      this.classList.remove('video-opened');

      // Set the IntersectionObserver
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Element in viewport
            this.onEnterViewport();
          } else {
            // Element out of viewport
            this.onExitViewport();
          } 
        });
      }, {
        threshold: [0.3, 1]
      });

      this.isHovered = false

      if(Boolean(this.dataset.hoverplay)) {
        const isVideoPlaying = (video) => {
          return !!(
            video &&
            !video.paused &&
            !video.ended &&
            video.readyState >= 2
          );
        }
        const playIngDom = []
        this.addEventListener('mouseenter', () => {
          const allVideo = document.querySelectorAll('video')
          for(let i=0; i<allVideo.length; i++) {
            if(isVideoPlaying(allVideo[i])) {
              playIngDom.push(allVideo[i])
            }
            allVideo[i].pause && allVideo[i].pause()
          }
          this.isHovered = true;
          console.log('Hover start');
          this.onEnterViewport()
        });
        
        this.addEventListener('mouseleave', () => {
          for(let i=0; i<playIngDom.length; i++) {
            playIngDom[i].play && playIngDom[i].play()
          }
          this.isHovered = false;
          this.onExitViewport();
          console.log('Hover end');
        });
      }

      // Observe the element
      this.observer.observe(this);

      this.querySelector('[data-js-video-component-link]').addEventListener('click', e => {
        e.preventDefault();
        this.loadVideoTemplate();
      });

    }

    loadVideoTemplate() {
      
      if(!this.querySelector('.video-component__blackout')) {
        const blackout = document.createElement('div');
        blackout.classList.add('video-component__blackout');
        this.append(blackout);
        setTimeout(() => {
          blackout.style.opacity = '1';
        }, 10);
      }

      this.classList.add('video-opened');

      if ( this.querySelector('[data-js-video-component-close]') ) {
        this.querySelector('[data-js-video-component-close]').addEventListener('click', () => {
          this.querySelectorAll('iframe, video').forEach(elm => { elm.remove() });
          blackout.remove();
          this.classList.remove('video-opened');
        });
      }

      setTimeout(() => {

        !this.querySelector('video') && this.querySelector('[data-js-video-component-container]').appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        setTimeout(() => {
          this._playMedia(this.closest('[data-video]'));
        }, this.dataset.autoplay === 'true' ? 1 : 500);

        if ( this.dataset.autoplay === 'true' ) {
          if ( this.querySelector('video') ) {
            console.log('has video')
            this.querySelector('video').addEventListener('canplay', () => {
              console.log('add video-playing', this)
              this.classList.add('video-playing');
            });
          } else {
            console.log('not video')
            this.classList.add('video-playing');
          }
        }

      }, 20);

    }

    onEnterViewport() {
      if(Boolean(this.dataset.hoverplay) && !this.isHovered) {
        return;
      }

      // Check if data-autoplay is true and if the popup is closed
      if ( this.dataset.autoplay === 'true' && !this.classList.contains('video-opened') ) {
        // open the popup
        if ( this.querySelector('[data-js-video-component-link]') ) {
          this.loadVideoTemplate();
        }
      }

      // play video if in viewport
      const media = this.closest('[data-video]');
      if ( media ) {
        this._playMedia(media);
      }

    }

    onExitViewport() {
      // pause video if outside the viewport
      const media = this.closest('[data-video]');
      if ( media ) {
        this._pauseMedia(media);
      }
    }

    _playMedia(media) {
      // triggers the PLAY function of each media type depending on it's source
      switch ( media.dataset.mediaType ) {
        case 'video':
          if ( media.querySelector('video') ) {
            media.querySelector('video').play().catch(error => {
              this.classList.add('video-playing'); // if the video is not autoplayed, add the class to show the poster
            });
          }
          break;
        case 'youtube':
          if ( media.querySelector('.js-youtube') ) {
            media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
          break;
        case 'vimeo':
          if ( media.querySelector('.js-vimeo') ) {
            const leVimeoFrame = media.querySelector('.js-vimeo');
            leVimeoFrame.contentWindow.postMessage('{"method":"play"}', '*');
          }
          break;
      }
    }

    _pauseMedia(media) {
      // triggers the PAUSE function of each media type depending on it's source 
      switch ( media.dataset.mediaType ) {
        case 'video':
          if ( media.querySelector('video') ) {
            media.querySelector('video').pause();
          }
          break;
        case 'youtube':
          if ( media.querySelector('.js-youtube') ) {
            media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
          break;
        case 'vimeo':
          if ( media.querySelector('.js-vimeo') ) {
            media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"pause"}', '*');
          }
          break;
      }
    }

    disconnectedCallback() {
      // 清理操作，比如移除事件监听器、销毁播放器实例、释放资源等
    }

  }

  if ( typeof customElements.get('video-component') == 'undefined' ) {
    customElements.define('video-component', VideoComponent);
  }

}